/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/train_medium'
export default icon
